import React from "react";
import "../css/privacy.scss";

function Cookies() {
  return (
    <main className="page-width page-width--narrow section-template--19439205515429__main-padding">
      <h1 className="main-page-title page-title h0">cookie policy</h1>
      <div className="rte">
        <p>Last updated: September 16, 2026</p>
        <p>This policy explains how tunrisefield uses cookies and similar browser storage when you visit our website.</p>
        <h2>What cookies are</h2>
        <p>Cookies are small data files stored by your browser. They help a website remember choices, keep a cart working, protect forms, and understand basic site performance.</p>
        <h2>Cookies we use</h2>
        <ul>
          <li><strong>Strictly necessary:</strong> maintain your shopping cart, checkout session, security settings, and saved cookie choices.</li>
          <li><strong>Functional:</strong> remember preferences such as region or display settings when enabled.</li>
          <li><strong>Analytics:</strong> help us understand aggregated page use and improve the site when analytics tools are enabled.</li>
          <li><strong>Marketing:</strong> support campaign measurement only when such tools are enabled and consent is required.</li>
        </ul>
        <h2>Your choices</h2>
        <p>You can delete or block cookies in your browser settings. Blocking strictly necessary storage may prevent the cart or checkout from working correctly. Where required by law, optional cookies will be used only after consent.</p>
        <h2>Changes to this policy</h2>
        <p>We may update this policy when our technology, providers, or legal obligations change. The date above identifies the latest version.</p>
        <h2>Contact</h2>
        <p>Questions about cookies or privacy can be sent to <a href="mailto:mall@tunrisefield.xyz">mall@tunrisefield.xyz</a> or mailed to Valle Morelia 120, Valle Soleado (FOMERREY-107), 67114 Guadalupe, N.L., MX.</p>
      </div>
    </main>
  );
}

export default Cookies;
